import { createContext, useContext } from "react"

interface DialogContextValue {
	inDialog: boolean
}

const DialogContext = createContext<DialogContextValue>({ inDialog: false })

/**
 * Hook to detect if component is rendered inside a dialog.
 * Used to adjust popover behavior to prevent z-index/interaction issues.
 */
export function useDialogContext() {
	return useContext(DialogContext)
}

export const DialogProvider = DialogContext.Provider
